<db-dialog-wrapper [dialog]="this" [fullScreen]="isMobile" [width]="'783px'" [height]="'311px'" [canClose]="!loading" [hasCloseButton]="!loading" [canCloseByBackdrop]="!loading">
  <div class="db-upload-csv-dialog db-upload-csv-dialog-sm">
    <div class="db-upload-csv-dialog__header">{{'text_uploadCsv.header' | dbText}}</div>
    <div class="db-upload-csv-dialog__message">
      <span [innerHTML]="'text_uploadCsv.message' | dbText"></span>
    </div>
    <div class="db-upload-csv-dialog__body">
      <input type="file" (change)="onFileSelect($event)">
    </div>
    <div class="db-upload-csv-dialog__buttons">
      <a class="ds-btn" (click)="cancel()" [ngClass]="{'ds-btn-disabled': loading}"><span>{{'text_cancel' | dbText}}</span></a>
      <a class="ds-btn-blue" (click)="uploadFile()" [ngClass]="{'ds-btn-disabled': loading}">
        <span *ngIf="!loading">{{'text_importRedirects' | dbText}}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
</db-dialog-wrapper>
